import { ISecondarySlotPropsMap } from 'redux-state/layout/types.layout.js';

export function hasSecondary(preparedSecondaryConfig: ISecondarySlotPropsMap): boolean {
  const { major, minor } = preparedSecondaryConfig;

  return major.modules.length > 0 || minor.modules.length > 0;
}
